<template>
  <FunBookV2BranchDetail :branch="branch" />
</template>

<script>
import { useEventListener } from '@vueuse/core'
import { useReferer } from '@/composition/useReferer'
import { useGoogleAppointment } from '@/composition/useGoogleAppointment'

export default defineComponent({
  name: 'FunBookBranchesPage',
  components: {
    FunBookV2BranchDetail: defineAsyncComponent(() => import('@/components/FunBookV2BranchDetail.vue')),
  },
  beforeRouteLeave() {
    this.$store.dispatch('dialog/setLoginDialog', { state: false })
    return true
  },
  setup() {
    definePageMeta({
      middleware: ['branch-funbook-middleware'],
    })
    const { $store: store } = useNuxtApp()
    const branch = computed(() => store.getters['branch/branch'])
    useReferer({ bid: branch.value.bid })
    const { deleteGoogleAppointment } = useGoogleAppointment(branch.value.bid)

    onMounted(() => {
      useEventListener(window, 'beforeunload', deleteGoogleAppointment)
    })

    return {
      branch,
    }
  },
})
</script>
